module.exports = __webpack_public_path__ + "static/media/upload.e09f5651.png";